import React from 'react';

function Image({
    src,
    alt = "Image Name",
    className = "",
    ...props
}) {

    return (
        <div className={`overflow-hidden bg-muted ${className}`}>
            <img
                src={src}
                alt={alt}
                className="w-full h-full object-cover transition-opacity duration-300 opacity-0"
                loading="lazy"
                decoding="async"
                onLoad={(e) => {
                    e.target.classList.remove('opacity-0');
                }}
                onError={(e) => {
                    e.target.src = "/assets/images/no_image.png"
                }}
                {...props}
            />
        </div>
    );
}

export default Image;
